export function truncateLabel(label, labelLengthOverflow) {
  return label.substring(0, labelLengthOverflow - 3) + '...';
}